module.exports = __webpack_public_path__ + "static/img/zx-yxzx-icon.0f6b6172.png";